module.exports = __webpack_public_path__ + "static/media/edit-canvas.2b6768b9.svg";